import { css } from 'emotion';

const statusIconText = css`
  span {
    span {
      width: 100%;
      display: inline-block;
      white-space: break-spaces;
    }
  }
`;

export default { statusIconText };
